import React, { useEffect, useState } from 'react';
import HeaderWithActions, {
  CustomButtonProps,
} from '../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../lib/designSystem/Table';
import {
  deleteBusinessContact,
  getAllCompanyContacts,
  selectContact,
} from '../../../../lib/api';
import { useDispatch } from 'react-redux';
import NewContact from './components/NewContact';
import CenteredCircularProgress from '../../../../lib/designSystem/CircularProgress';
import { showAlert } from '../../../../lib/functions/utils';
import GlobalSearcher, { Filter } from '../../../../lib/common/GlobalSearcher';

const headers = [
  { key: 'name', label: 'Nombre contacto' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Teléfono' },
  { key: 'role', label: 'Rol' },
  { key: 'businessName', label: 'Empresa' },
  { key: 'observation', label: 'Observaciones' },
  { key: 'selected', label: 'Principal', type: 'boolean-active-null' },
];

const emptyContact = {
  name: '',
  email: '',
  role: '',
  phone: '',
  customRole: '',
};

const Main: React.FC = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [contact, setContact] = useState(emptyContact);
  const [contacts, setContacts] = useState<any[]>([]);
  const [businessFilter, setBusinessFilter] = useState<any>('all');
  const [roleFilter, setRoleFilter] = useState<any>('all');
  const [filteredContacts, setFilteredContacts] = useState<any[]>([]);

  const hanldeNewContact = async () => {
    setContact(emptyContact);
    setOpenModal(true);
  };

  const handleEdit = (id: number) => {
    const contact = contacts.find((x: any) => x.id === id);
    if (!contact) return alert('Ha ocurrido un error');
    setContact(contact);
    setOpenModal(true);
  };

  const handleDelete = async (id: number) => {
    const contact: any = contacts.find((x: any) => x.id === id);
    setLoading(true);
    try {
      const response = await deleteBusinessContact(
        dispatch,
        contact.business.id,
        {
          contactId: contact.id,
        },
      );
      if (response) {
        showAlert(dispatch, 'success', 'Contacto eliminado con éxito');
        await setUp();
      }
    } catch (error) {
      showAlert(dispatch, 'error', 'Ha ocurrido un error');
    }
    setLoading(false);
  };

  const handleSelectMain = async (id: number) => {
    const contact: any = contacts.find((x: any) => x.id === id);
    if (!contact) return alert('Ha ocurrido un error');
    try {
      const response = await selectContact(
        dispatch,
        contact?.business.identifier,
        {
          id: contact.business.identifier,
          contactId: contact.id,
          main: true,
        },
      );
      console.log(response);
      if (response) {
        showAlert(
          dispatch,
          'success',
          'Contacto principal seleccionado con éxito',
        );
        setUp();
      } else {
        showAlert(dispatch, 'error', 'Ha ocurrido un error');
      }
    } catch (error) {
      showAlert(dispatch, 'error', 'Ha ocurrido un error');
    }
  };

  const actions = [
    {
      action: handleEdit,
      actionLabel: 'Editar',
    },
    {
      action: handleSelectMain,
      actionLabel: 'Seleccionar como principal',
    },
    {
      action: handleDelete,
      actionLabel: 'Eliminar contacto',
    },
  ];

  const filters: Filter[] = [
    {
      type: 'select',
      label: 'Empresa',
      value: businessFilter,
      setter: setBusinessFilter,
      options: [
        { value: 'all', label: 'Todos' },
        ...[...new Set(contacts.map((x: any) => x.businessName))].map(
          (x: any) => ({
            value: x,
            label: x,
          }),
        ),
      ],
    },
    {
      type: 'select',
      label: 'Rol',
      value: roleFilter,
      setter: setRoleFilter,
      options: [
        { value: 'all', label: 'Todos' },
        ...[...new Set(contacts.map((x: any) => x.role))].map((x: any) => ({
          value: x,
          label: x,
        })),
      ].filter(
        (x: any) => typeof x.value === 'string' && x.value.trim() !== '',
      ),
    },
  ];

  const handleSearch = async () => {
    let filtered = contacts.filter((x: any) =>
      businessFilter === 'all' ? true : x.businessName === businessFilter,
    );
    filtered = filtered.filter((x: any) =>
      roleFilter === 'all' ? true : x.role === roleFilter,
    );
    setFilteredContacts(filtered);
  };

  const buttons: CustomButtonProps[] = [
    {
      name: 'Buscar',
      action: () => {},
      color: 'primary',
      customButton: (
        <GlobalSearcher filters={filters} triggerSearch={handleSearch} />
      ),
    },
    {
      name: 'Nuevo contacto',
      action: () => hanldeNewContact(),
      color: 'primary',
    },
  ];

  const setUp = async () => {
    try {
      const contactsResponse = await getAllCompanyContacts(dispatch);
      console.log(contactsResponse);
      setContacts([...contactsResponse]);
      setFilteredContacts([
        ...contactsResponse.map((x: any) => ({
          ...x,
          role: x.role === 'Otro' ? x.customRole : x.role,
        })),
      ]);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    setUp();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;

  return (
    <div>
      <HeaderWithActions
        type="subHeader"
        variant="body1"
        buttons={buttons}
        title="Esta es toda tu red de contactos."
      />
      <EnhancedTable
        dataHeaders={headers}
        data={filteredContacts}
        showActions
        rowsPerPageDefault={50}
        actions={actions}
        lastElement
      />
      <NewContact
        open={openModal}
        setOpen={setOpenModal}
        contact={contact}
        setContact={setContact}
        setUp={setUp}
      />
    </div>
  );
};

export default Main;
